import { useCurrentStateAndParams } from "@uirouter/react";
import { useSelector } from "react-redux";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";
import { i18nFilter } from "app/filters/i18nFilter";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";

import { SegmentsComparisonContainer } from "./features/segments-comparison/SegmentsComparisonContainer";
import ComparisonTableEmptyState from "./features/segments-homepage/ComparisonTableEmptyState";
import LimitationDisclaimer from "./features/segments-homepage/LimitationDisclaimer";
import { SegmentsStartPageEmptyState } from "./features/segments-homepage/SegmentsStartPageEmptyState";
import { SegmentTableTabs } from "./features/segments-homepage/SegmentTableTabs";
import { SegmentsContainer } from "./features/segments-homepage/StyledComponents";

export const SegmentsHomepageContainer = () => {
    const autoScrollRef = useAutoScrollTop();
    const { params } = useCurrentStateAndParams();
    const isMidTierUser = SegmentsUtils.isMidTierUser();
    const { segments, organizationSegments, groups, isLoading } = useSelector((state) => {
        const {
            segmentsModule: { segmentsLoading, customSegmentsMeta },
        } = state;
        return {
            segments: customSegmentsMeta?.Segments,
            organizationSegments: customSegmentsMeta?.AccountSegments,
            groups: customSegmentsMeta?.SegmentGroups,
            isLoading: segmentsLoading,
        };
    });

    const hasSegments = organizationSegments?.length > 0;
    const hasGroups = groups?.length > 0;

    if (!hasSegments) {
        return <SegmentsStartPageEmptyState />;
    }

    return (
        <div className="sw-layout-module-inner">
            <div
                className="sw-layout-scrollable-element use-sticky-css-rendering fadeIn"
                ref={autoScrollRef}
            >
                <Flex
                    justifyContent="center"
                    padding="32px"
                >
                    <Stack
                        width="100%"
                        maxWidth="1080px"
                        gap="24px"
                    >
                        <Text
                            className="PageTitle"
                            data-automation="segments-homepage-title"
                            fontVariant="h4"
                            color={colorsPalettes.carbon["500"]}
                        >
                            {i18nFilter()("segment.analysis.startpage.title")}
                        </Text>
                        <LimitationDisclaimer />
                        {isMidTierUser || !hasGroups ? (
                            <ComparisonTableEmptyState
                                isMidTierUser={isMidTierUser}
                                hasGroups={hasGroups}
                            />
                        ) : (
                            <SegmentsComparisonContainer
                                segments={segments}
                                organizationSegments={organizationSegments}
                                groups={groups}
                                isLoading={isLoading}
                            />
                        )}
                        <SegmentsContainer>
                            <SegmentTableTabs
                                segments={segments}
                                organizationSegments={organizationSegments}
                                params={params}
                                isLoading={isLoading}
                            />
                        </SegmentsContainer>
                    </Stack>
                </Flex>
            </div>
        </div>
    );
};
